import React from 'react';
import { Action } from 'redux';
import { Box, Typography } from '@mui/material';

export interface DataTimerAction extends Action {
  timerId: string;
}

export type DataTimerState = Dictionary<boolean>;

export enum DataTimerActions {
  SAVE_TIMER = 'SAVE_TIMER',
  CLEAR_TIMER = 'CLEAR_TIMER',
}

export const saveTimer = (timerId: string) => ({
  type: DataTimerActions.SAVE_TIMER,
  timerId,
});

export const clearTimer = (timerId: string) => ({
  type: DataTimerActions.CLEAR_TIMER,
  timerId,
});

const initialState = {};

export const dataTimerReducer = (
  state: DataTimerState = initialState,
  action: DataTimerAction = {} as DataTimerAction,
) => {
  const { type, timerId } = action;

  if (type === DataTimerActions.SAVE_TIMER) {
    return {
      ...state,
      [timerId]: true,
    };
  }

  if (type === DataTimerActions.CLEAR_TIMER) {
    return {
      ...initialState,
      [timerId]: false,
    };
  }

  return state;
};

interface DataTimerProps {
  isActive?: boolean;
  children?: React.ReactElement;
  timerLifetime: number;
}

const BACK_ANIMATION_SPEED = 1000;

const DataTimer = ({ isActive = true, children, timerLifetime }: DataTimerProps) => {
  return (
    <Box
      className="timer__wrapper"
      sx={{
        position: 'relative',
        borderRadius: '4px',
        backgroundColor: 'error.main',
        overflow: 'hidden',
        minWidth: '100px',
        minHeight: '25px',
        '&:has(button.Mui-disabled)': {
          backgroundColor: 'transparent',
          '& .timer__counter': { backgroundColor: 'transparent' },
        },
      }}
    >
      <Typography
        component="span"
        variant="inherit"
        className="timer__counter"
        sx={{
          backgroundColor: 'error.main',
          display: 'inline-block',
          height: '100%',
          position: 'absolute',
          top: 0,
          right: 0,
          transition: `${isActive ? timerLifetime : BACK_ANIMATION_SPEED}ms linear width`,
          width: `${isActive ? 0 : 100}%`,
        }}
      />
      <Box
        className="button__wrapper"
        sx={{
          zIndex: 1,
          position: 'relative',
          '& button:not(:hover):not(.Mui-disabled)': {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default DataTimer;
